import { API, API_EMAIL_SENDER } from "../config";
const axiosRequest = require("axios");

export const V1 = axiosRequest.create({
  baseURL: API,
});

export const api = axiosRequest.create({});

// Request interceptor for API calls
api.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers = {
        Authorization: `Bearer ${token}`,
        "x-auth-token": token,
      };
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// Request interceptor for API calls
V1.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers = {
        Authorization: `Bearer ${token}`,
        "x-auth-token": token,
      };
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

export const V2 = axiosRequest.create({
  baseURL: API_EMAIL_SENDER,
});

// Request interceptor for API calls
V2.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers = {
        Authorization: `Bearer ${token}`,
        "x-auth-token": token,
      };
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);
